<template>
  <div class="uploadal">
    <h2
      v-if="filteredUploads.length">
        Submitted work
    </h2>
    <div class="announcements"
      v-for="uploadedfile in filteredUploads"
      :key="uploadedfile.id">
        <div v-if="error">
        {{ error }}
        <Spinner />
        </div>
        <div
        v-if="filteredUploads.length"
        class="layout"
        >
        <ClassUploadsDetails
            :record="uploadedfile"
            @deletion="deleted"
            />
        </div>
        <div
        v-else
        class="card"
        >
        <p>No homework found at the moment, check back later</p>
        <Spinner />
        </div>
    </div>
  </div>
</template>

<script>
// component imports
import Spinner from '@/components/Spinner.vue'
import ClassUploadsDetails from '@/components/ClassUploadsDetails.vue'
import getPosts from '@/composables/getPosts'
import { ref, watchEffect } from '@vue/runtime-core'

export default {
  name: 'LearnerUploads',
  props: ['uploader'],
  emits: ['filedeleted'],
  components: { Spinner, ClassUploadsDetails },
  setup (props, context) {
    const filteredUploads = ref(null)
    const { myData, error, load } = getPosts()

    load(props.uploader.grade + '/uploads/learner')
    const deleted = () => {
      context.emit('filedeleted')
    }

    watchEffect(() => {
      filteredUploads.value =
        myData.value ? myData.value.filter(leaderFile => leaderFile.lid === props.uploader.user.uid)
          : null
    })

    return { error, filteredUploads, deleted }
  }
}
</script>

<style>
  .uploadal {
    max-width: 960px;
    margin: 0 auto;
  }
</style>
